/** Each award's badge: a drawn starburst with the award's own icon in the middle. */

import {
  AtSign,
  AudioWaveform,
  BookOpen,
  CalendarDays,
  CaseLower,
  CircleDot,
  CircleHelp,
  Crown,
  EyeOff,
  Film,
  Flag,
  Flame,
  Gem,
  Ghost,
  Headphones,
  HeartHandshake,
  Hourglass,
  Image,
  Laugh,
  Link,
  Magnet,
  Megaphone,
  MessagesSquare,
  Moon,
  Music,
  PenLine,
  PhoneCall,
  Pin,
  RotateCcw,
  Siren,
  Skull,
  Smile,
  SmilePlus,
  Snowflake,
  Sparkles,
  Star,
  Sunrise,
  TrendingUp,
  Type,
  Zap,
  type LucideIcon,
} from "lucide-react";

export const AWARD_ICONS: Record<string, LucideIcon> = {
  icebreaker: Snowflake,
  speed_demon: Zap,
  left_on_read: Hourglass,
  novelist: BookOpen,
  one_word_wonder: Type,
  editor: PenLine,
  double_texter: MessagesSquare,
  three_am_club: Moon,
  early_bird: Sunrise,
  last_word: Flag,
  necromancer: Skull,
  caps_lock: Megaphone,
  question_mark: CircleHelp,
  streak: Flame,
  call_captain: Headphones,
  call_starter: PhoneCall,
  hall_of_fame: Pin,
  comedian: Laugh,
  laugh_track: Smile,
  main_character: Star,
  summoner: AtSign,
  reply_magnet: Magnet,
  viral_moment: TrendingUp,
  ghost: Ghost,
  comeback_kid: RotateCcw,
  apologiser: HeartHandshake,
  exclamation_station: Siren,
  nooooo_champion: AudioWaveform,
  lowercase_loyalist: CaseLower,
  full_stop: CircleDot,
  emoji_overlord: SmilePlus,
  meme_lord: Image,
  gif_goblin: Film,
  link_dumper: Link,
  the_dj: Music,
  rename_royalty: Crown,
  weekend_warrior: CalendarDays,
  spoiler_alert: EyeOff,
  special_guest_star: Sparkles,
  quality_over_quantity: Gem,
};

/** Twelve points, alternating long and short, around the middle of a 100×100 box. */
const STAR = Array.from({ length: 24 }, (_, i) => {
  const angle = (Math.PI * i) / 12 - Math.PI / 2;
  const radius = i % 2 ? 41 : 50;
  return `${(50 + radius * Math.cos(angle)).toFixed(2)},${(50 + radius * Math.sin(angle)).toFixed(2)}`;
}).join(" ");

export function AwardBadge({ id, size = 64 }: { id: string; size?: number }) {
  const Icon = AWARD_ICONS[id] ?? Star;
  return (
    <span className="relative inline-flex shrink-0 items-center justify-center" style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full" aria-hidden>
        <polygon points={STAR} className="fill-current opacity-20" />
        <circle cx="50" cy="50" r="33" className="fill-none stroke-current" strokeWidth="3" />
      </svg>
      <Icon size={size * 0.42} strokeWidth={2.2} aria-hidden />
    </span>
  );
}
